// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__wynnZ","emails":"CreateEditClinics_emails__F2-cA","emailTagLabel":"CreateEditClinics_emailTagLabel__1JAnI"};